"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEmailAutomationSubjects = void 0;
const getEmailAutomationSubjects = (name = "") => {
    return {
        EngagementT1: "Welcome to Brandqrcodes 🚀",
        EngagementT2: "You’re In! Here’s What Happens Next 🚀 ",
        EngagementT3: "You’ve Got the Power—Here’s What You Can Do with BrandQrCodes 🚀",
        EngagementT4: "How Smart QR Codes Are Changing the Game—And How You Can Too 🚀",
        EngagementT5: "Don’t Just Take Our Word for It—See the Results Yourself 🚀",
        EngagementT6: `We Miss You ${name} 🥺!`,
        SignUpT1: "Elevate Your Brand with BrandQRCodes - Your QR Solution Partner! 🚀",
        AnnouncementT1: "Exciting News: Introducing Referral Program Upgrades on brandqrcodes.com!",
        CartT1: "Did you forget something amazing?",
        CartT2: "Did you forget about your favorites at brandqrcodes.com?",
        CartT3: "Hold on a sec! We can help complete your purchase.",
        CartT4: "Thanks for choosing brandqrcodes.com!",
        PetsSignUpT1: "A Smarter Way to Keep Pets Safe and Organized",
        PetsSignUpT2: "Stand Out as a Pet Business That Cares 💡",
        ImagesSignUpT1: "Showcase Your Best Work and Attract More Clients",
        ImagesSignUpT2: "Ready to Book More Clients with Your Portfolio?",
        BusinessSignUpT1: "A Smarter Way to Package Your Clients’ Brands 🚀",
        BusinessSignUpT2: "Give Your Clients More Than Just a Logo—Give Them Visibility 🚀",
        MemoriesSignUpT1: "Relive your Event Memories with a Simple Scan",
        MemoriesSignUpT2: "Don’t Miss Out on Creating Lasting Memories for Your Guests",
        RestaurantSignUpT1: "Smarter Menus for Smarter Businesses",
        RestaurantSignUpT2: "Let’s Talk About Your Menu’s Potential",
        VisitsConsumedT1: "Your QR Code Is Inactive – Don’t Lose Your Traffic 🚀",
        VisitsConsumedRestaurantsT2: "Why Top Restaurants Are Upgrading Their QR Codes 🍽️🚀",
        VisitsConsumedPhotographersT2: "More Clients, More Bookings—Here’s How 📸✨",
        VisitsConsumedEventPlannersT2: "Make Every Event a Marketing Tool for Your Next Big Booking 🎯🎉",
        VisitsConsumedT3: "Real People. Real Results. Real Innovation.",
        VisitsConsumedT4: "48 Hours Only: Unlock Exclusive Savings on Your QR Codes! ⏳💡",
        VisitsConsumedT5: "🚨 Your QR Code is Still Inactive!",
    };
};
exports.getEmailAutomationSubjects = getEmailAutomationSubjects;
